export default {"src":"/_next/static/media/faq.dbdda793.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};